import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../CSS/Carousel.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Banner from "../../Images/Banner.png";
import img from "../../Images/profile.png";
import { fetchOffers } from "../../Features/offers/OfferSlice";
import { API_OFFER, READ_ALL_BANNER_OFFERS } from "../../Api/apiConstant";
import { useGetAPIWithoutTokenQuery } from "../../Api/api";
import { CircularProgress } from "@material-ui/core";


const OfferCarousel = () => {
  const dispatch = useDispatch();
  const { offers, loading, error } = useSelector((state) => state.offers);
  const eventId = sessionStorage.getItem("event_id");

  const { data, isLoading, isError, isSuccess } =
    useGetAPIWithoutTokenQuery(API_OFFER);

  const {
    data: bannerOffer,
    isLoading: BannerDataLoading,
    isError: bannerDataError,
  } = useGetAPIWithoutTokenQuery(
    `${READ_ALL_BANNER_OFFERS}?event_id=${eventId}`, { refetchOnMountOrArgChange: true, skip: !eventId }
  );


  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    dispatch(fetchOffers());
  }, [dispatch]);

  const isOffersArray = Array.isArray(offers) && offers?.length > 0;

  const todaysDate = new Date();
  const carouselData = bannerOffer?.data?.length > 0 ? bannerOffer.data.map((offer) => offer.offer_img_path) : [];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselData?.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? carouselData?.length - 1 : prevIndex - 1
    );
  };

  const latestOffers = isOffersArray ? offers.slice(1).slice(-3).reverse() : [];

  if (isLoading) {
    return (
      <div
        style={{
          height: "80vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress color="secondary" />
      </div>
    );
  }

  return (
    <>
      {carouselData.length > 0 ?
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "65vh",
            maxHeight: "max-content",
            position: "relative",
            width: "100%",
            maxWidth: "91.6%",
            margin: "0 auto",
          }}
        >
          <div className="carousel-container w-100">
            {carouselData.length > 1 && <button
              className="carousel-button prev-button"
              onClick={prevSlide}
              style={{
                position: "absolute",
                top: "50%",
                left: "1%",
                zIndex: 1,
                height: "5vh",
                width: "5vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={require("../../Images/arrowLeft.png")}
                style={{ objectFit: "contain", height: "2vh", width: "2vh" }}
              />
            </button>}

            <div
              style={{
                height: "100%",
                width: "100%",
              }}
            >
              <img
                src={carouselData?.[currentIndex] || ""}
                alt=""
                style={{ objectFit: "fill", height: "100%", width: "100%" }}
              />
            </div>

            {carouselData.length > 1 && <button
              className="carousel-button next-button"
              onClick={nextSlide}
              style={{
                position: "absolute",
                top: "50%",
                right: "1%",
                zIndex: 1,
                height: "5vh",
                width: "5vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={require("../../Images/arrowNew.png")}
                style={{ objectFit: "contain", height: "2vh", width: "2vh" }}
              />
            </button>}

            {/* Dots navigation */}
            {carouselData.length > 1 && <div
              style={{
                position: "absolute",
                bottom: "5vh",
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              {carouselData.length > 0 && carouselData &&
                carouselData?.map((_, index) => (
                  <div
                    key={index}
                    style={{
                      height: "1vh",
                      width: "1vh",
                      margin: "0 5px",
                      borderRadius: "50%",
                      backgroundColor:
                        currentIndex === index ? "red" : "transparent",
                      borderWidth: currentIndex === index ? "3px" : "1px",
                      borderStyle: "solid",
                      borderColor: currentIndex === index ? "transparent" : "grey",
                      transition:
                        "background-color 0.3s ease, border-width 0.3s ease",
                    }}
                  ></div>
                ))}
            </div>}
          </div>

          <div>
            {latestOffers.map((offer, index) => (
              <div
                key={index}
                className="carousel-text"
                style={{
                  position: "absolute",
                  top: `${(index + 1) * 10}vh`,
                  left: "10%",
                  fontSize: "20px",
                  fontWeight: "600",
                }}
              >
                {offer?.offer_name}
              </div>
            ))}
          </div>
        </div>
        : ""
      }
    </>
  );
};

export default OfferCarousel;
